import {z} from 'zod';

export const PerkAccessStatusSchema = z.enum(['used', 'unused']);
export type PerkAccessStatus = z.infer<typeof PerkAccessStatusSchema>;

export const PerkAccessObtentionTypeSchema = z.enum(['order', 'challenge', 'airdrop', 'transfer']);
export type PerkAccessObtentionType = z.infer<typeof PerkAccessObtentionTypeSchema>;
